import { render, staticRenderFns } from "./payTaxesLog.vue?vue&type=template&id=3b045e40&scoped=true"
import script from "./payTaxesLog.vue?vue&type=script&lang=js"
export * from "./payTaxesLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b045e40",
  null
  
)

export default component.exports